import api from '@/helpers/api';

export default {
  login({ commit }, payload) {
    payload.forceApi = true;
    api('POST', 'auth/login', payload, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('AUTH_SUCCESS', response.data);
          commit('SET_USER', response.data);
          commit('USER_LOADED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  autologin({ commit }, payload) {
    payload.forceApi = true;
    api('POST', 'auth/autologin', payload, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('AUTH_SUCCESS', response.data);
          commit('SET_USER', response.data);
          commit('USER_LOADED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  register({ commit }, payload) {
    api('POST', 'auth/register', payload, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('AUTH_SUCCESS', response.data);
          commit('SET_USER', response.data);
          commit('USER_LOADED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },

  fetchUser({ commit }) {
    commit('USER_LOADED', false);
    const request = api('GET', 'user/data', null, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('SET_USER', response.data);
          commit('USER_LOADED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
    return request;
  },
  // deprecated
  updateUser({ commit }, payload) {
    commit('SET_SUCCESS_UPDATE', false);
    api('PUT', 'users/data', payload)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_USER', response.data);
          commit('SET_SUCCESS_UPDATE', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updateMemberData({ commit }, payload) {
    payload.forceApi = true;
    const request = api('PUT', '/user/data', payload, null, 'w');
    request.then((response) => {
      if (response.status === 200) {
        commit('SET_USER', response.data);
      }
    });
    return request;
  },
  // deprecated
  updateAvatar({ commit }, payload) {
    api('POST', 'users/avatar', payload, {
      'Content-Type': 'multipart/form-data',
    })
      .then((response) => {
        if (response.status === 200) {
          commit('SET_AVATAR', response.data.avatar);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updateMemberAvatar({ commit }, payload) {
    const request = api('POST', '/user/avatar', payload, { 'Content-Type': 'multipart/form-data' }, 'w');
    request.then((response) => {
      if (response.status === 200) {
        commit('SET_AVATAR', response.data.avatar);
      }
    });
    return request;
  },
  // deprecated
  updateUserData({ commit }, payload) {
    commit('SET_SUCCESS_EMAIL_UPDATE', false);
    api('PUT', 'users/email', payload)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_SUCCESS_EMAIL_UPDATE', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updateMemberEmail({ commit }, payload) {
    payload.forceApi = true;
    const request = api('PUT', '/user/email', payload, null, 'w');
    request.then((response) => {
      if (response.status === 200) {
        commit('SET_EMAIL', payload.email);
      }
    });
    return request;
  },
  checkPassword({ commit }, payload) {
    commit('SET_CHECKING_PASSWORD', true);
    return new Promise((resolve, reject) => {
      api('POST', 'users/password-check', payload)
        .then((response) => {
          commit('SET_CHECKING_PASSWORD', false);
          resolve(response.data);
        })
        .catch((error) => {
          commit('SET_CHECKING_PASSWORD', false);
          reject(error);
        });
    });
  },
  requestPhoneVerification({ commit }, payload) {
    api('POST', 'users/send-phone-verify-code', payload)
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updatePhone({ commit }, payload) {
    commit('SET_SUCCESS_PHONE_UPDATE', false);
    api('PUT', 'users/phone', payload)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_SUCCESS_PHONE_UPDATE', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  verifyPhone({ commit }, payload) {
    commit('PHONE_VERIFY_FINISHED', false);
    api('POST', 'users/verify-phone', payload)
      .then((response) => {
        if (response.status === 200) {
          commit('PHONE_VERIFY_FINISHED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  deletePhone({ commit }) {
    commit('DELETING_PHONE_IN_PROGRESS', true);
    api('DELETE', 'users/phone')
      .then(() => {
        commit('DELETING_PHONE_IN_PROGRESS', false);
      })
      .catch((error) => {
        commit('DELETING_PHONE_IN_PROGRESS', false);
        commit('API_ERROR', error.response);
      });
  },
  // Deprecated
  updateUserPassword({ commit }, payload) {
    commit('SET_SUCCESS_PASSWORD_UPDATE', false);
    api('PUT', 'users/password', payload)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_SUCCESS_PASSWORD_UPDATE', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updateMemberPassword(_, payload) {
    payload.forceApi = true;
    return api('PUT', '/user/password', payload, null, 'w');
  },
  // Deprecated
  fetchSettings({ commit }) {
    commit('USER_SETTINGS_LOADING', true);
    api('GET', 'users/settings')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_USER_SETTINGS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      })
      .finally(() => {
        commit('USER_SETTINGS_LOADING', false);
      });
  },
  fetchNotificationSettings({ commit }) {
    commit('USER_SETTINGS_LOADING', true);
    const request = api('GET', 'user/notifications', null, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('SET_USER_SETTINGS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      })
      .finally(() => {
        commit('USER_SETTINGS_LOADING', false);
      });
    return request;
  },
  updateNotificationSettings(_, payload) {
    const request = api('PUT', 'user/notifications', payload.data, null, 'w');
    return request;
  },
  // Deprecated
  updateSettings({ commit }, payload) {
    commit('SET_SUCCESS_SETTINGS_UPDATE', false);
    api('PUT', 'users/settings', payload)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_SUCCESS_SETTINGS_UPDATE', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },

  changeAvailability({ commit }, payload) {
    api('PUT', `merchants/${payload.merchantId}/user-availability`, { available: payload.state })
      .then((response) => {
        if (response.status === 200) {
          commit('SET_USER_AVAILABILITY', payload.state);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },

  setOneSignalId({ commit }, payload) {
    api('POST', 'user/one-signal', payload, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('ONESIGNAL_ID_ADDED', payload);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  removeOneSignalId({ commit }, oneSignalId) {
    api('DELETE', `user/one-signal/${oneSignalId}`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('ONESIGNAL_ID_REMOVED', oneSignalId);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },

  // deprecated
  fetchMerchantRoles({ commit }) {
    api('GET', 'user/roles', null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_MERCHANT_ROLES', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  /** Fetches user roles for all the organisations at once. */
  // fetchOrganisationRoles({ commit }) {

  // },
  acceptMerchantInvitation({ commit }, payload) {
    const response = api('POST', 'accept-invitation', payload, null, 'w');
    response
      .then((response) => {
        if (response.status === 200) {
          commit('INVITATION_ACCEPTED', payload);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
    return response;
  },

  resetPasswordRequest({ commit }, payload) {
    commit('PASSWORD_RESET_SENT', false);
    api('POST', 'auth/reset-password', payload, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('PASSWORD_RESET_SENT', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  resetPassword({ commit }, payload) {
    commit('PASSWORD_RESET_SENT', false);
    api('POST', 'auth/reset-password-store', payload, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('AUTH_SUCCESS', response.data);
          commit('SET_USER', response.data);
          commit('USER_LOADED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },

  changePaymentCard({ commit }, payload) {
    commit('PAYMENT_CARD_CHANGED', false);
    delete payload.business_id;
    const request = api('PUT', `/organisation/${payload.organisationId}/billing/card/save`, payload.data, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('PAYMENT_CARD_CHANGED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
    return request;
  },
  logout({ commit, dispatch }) {
    api('POST', 'auth/logout', { forceApi: true }, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('USER_SIGNED_OUT', true);
          dispatch('organisation/setCurrentNumber', null, { root: true });
          dispatch('organisation/initialized', false, { root: true });
        }
      }).catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  clearApiError({ commit }) {
    commit('CLEAR_API_ERROR');
  },
  permission_denied({ commit }, payload) {
    commit('SET_PERMISSION_DENIED', payload);
  },
  resetAccess({ commit }) {
    commit('RESET_ACCESS');
  },
};
